@if (areMiniGamesEnabled) {
    <div class="mini-games-column">
        <div class="options-panel single-tab" (click)="panelToggled()">
            <div class="mini-games-header">{{ sitecore.globalMessages.MiniGames }}</div>
            <ms-expansion-panel class="expansion-panel" [collapsed]="collapsed" />
        </div>
        <ms-minigames [hidden]="collapsed" />
    </div>
}
